// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8d6aa933","44":"0fa5ec5b","59":"56f177d0","72":"1d283d13","151":"8b68ed60","213":"da49e776","432":"23a26ec4","636":"5d5d19e4","680":"c9b4fa46","691":"18bebe47","838":"7a8fc5b7","892":"740c6d99","897":"3cb30626","899":"6116b68c","971":"2151ced5","973":"550b3f50"}[chunkId] + ".chunk.js";
};